import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Version5Module } from "./version5/version5.module";
import { NivelActionModule } from "./nivelAction/nivelAction.module";
//import { EvaluadorComponent } from './evaluador/evaluador.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    Version5Module,
    NivelActionModule,
  ]
})
export class ActiongoModule { }
